import { Typography } from "@mui/material";

interface ImageTagProps {
  tag: string | undefined;
}

const ImageTag: React.FC<ImageTagProps> = ({ tag }) => {  
  if (!tag || tag === "Unassigned") return <></>;

  return (
    <Typography
      variant="caption"
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        color: "#fff",
        padding: "6.5px",
        borderRadius: "4px",
        fontWeight: "bold",
        lineHeight: 1.2,
      }}
    >
      {tag}
    </Typography>
  );
};

export default ImageTag;
